import $ from 'jquery';
import breakpoint from '../scripts/breakpoint';

$.addInit(function(context){
	var base = '.b-menu';
	$(base, context).each(function(){
		var component = $(this);
		var catalogLink = component.find(base + '-catalogLink');
		var subMenu = catalogLink.siblings('.b-subMenu');
		var isActive = false;
		var overlay = $('<div>', {
			'class': 'b-overlay'
		});

		function setActive(value) {
			catalogLink.toggleClass('m-active', value);
			subMenu.toggleClass('m-active', value);
			$(document)[value ? 'on' : 'off']('click', closeHandler);

			if (value) {
				overlay.appendTo('body')
			} else {
				overlay.detach()
			};

			isActive = value;
		}

		function toggleHandler(e) {
			e.preventDefault();

			if (!catalogLink.hasClass('m-active')) {
				setTimeout(function() {
					setActive(true);
				});
			} else {
				setTimeout(function() {
					setActive(false);
				});
			}
		}

		function closeHandler(e) {
			if ($(e.target).closest(subMenu).length === 0) {
				setActive(false);
			}
		}

		breakpoint(null, 'lg')
			.onmatch(function(){
				catalogLink.on('click', toggleHandler);
			})
			.onmismatch(function() {
				catalogLink.on('click', toggleHandler);
			});
	});
});


//////////////////
// WEBPACK FOOTER
// ./src/components/b-menu.js
// module id = 43
// module chunks = 0